import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import ProfilePicture from "../shared/profilePicture";
export default class MeetingWithDisplay extends PureComponent {
    renderSelectedLocation() {
        const location = this.props.meetingWith && this.props.meetingWith.locationName;
        if (!location) {
            return null;
        }
        return (_jsx("a", { href: location.url, target: "_blank", rel: "noopener noreferrer", children: _jsxs("small", { children: [_jsx("span", { className: "fas fa-map-marker-alt", "aria-hidden": "true" }), " ", location.name] }) }));
    }
    render() {
        return (_jsxs("div", { className: "media", children: [_jsx("div", { className: "mr-3", children: _jsx(ProfilePicture, { person: this.props.meetingWith }) }), _jsxs("div", { className: "media-body", children: [_jsxs("h6", { className: "media-heading mb-1", children: ["Meeting with ", this.props.meetingWith.fullName] }), _jsx("div", { children: this.renderSelectedLocation() })] })] }));
    }
}
